import { twx } from '~/utils/twx';

export const Badge = twx.span`bg-active typography text-default absolute top-0 right-0 translate-x-[40%] -translate-y-[50%] rounded-full px-[6px] text-sm shadow-[0_0_2px_1px_rgba(0,0,0,0.5)]`;
